const translations = {
	form: {
		header: {
			de: "Durchsuchen Sie die Veranstaltungen",
			en: "Search events",
		},
		submitBtn: {
			de: "Suchen",
			en: "Search",
		},
		submitBtnAriaLabel: {
			de: "Jetzt suchen",
			en: "Search now",
		},
		resetBtn: {
			de: "Filter zurücksetzen",
			en: "Reset filter",
		},
		resetBtnAriaLabel: {
			de: "Filter zurücksetzen",
			en: "Reset filter",
		},
	},
	textInput: {
		label: {
			de: "Suchbegriff",
			en: "Search term",
		},
		placeholder: {
			de: "Suchbegriff eingeben",
			en: "Enter search term",
		},
	},
	listboxFromYear: {
		label: {
			de: "Von Jahr",
			en: "From year",
		},
		placeholder: {
			de: "Jahr auswählen",
			en: "Select year",
		},
	},
	listboxFromMonth: {
		label: {
			de: "Von Monat",
			en: "From month",
		},
		placeholder: {
			de: "Monat auswählen",
			en: "Select month",
		},
		labelDisabled: {
			de: "Bitte wählen Sie zuerst ein Jahr aus",
			en: "Please select a year first",
		},
	},
	listboxToYear: {
		label: {
			de: "Bis Jahr",
			en: "To year",
		},
		placeholder: {
			de: "Jahr auswählen",
			en: "Select year",
		},
	},
	listboxToMonth: {
		label: {
			de: "Bis Monat",
			en: "To month",
		},
		placeholder: {
			de: "Monat auswählen",
			en: "Select month",
		},
		labelDisabled: {
			de: "Bitte wählen Sie zuerst ein Jahr aus",
			en: "Please select a year first",
		},
	},
	general: {
		months: {
			de: [ 'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember' ],
			en: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ],
		},
	},
	teaser: {
		category: {
			de: "Veranstaltung",
			en: "Event",
		},
		readMore: {
			de: "Weiterlesen",
			en: "Read more",
		},
	},
	resultList: {
		labelReadMore: {
			de: "Weiterlesen",
			en: "Read more",
		},
		labelResultCountSingular: {
			de: "Ergebnis",
			en: "result",
		},
		labelResultCountPlural: {
			de: "Ergebnisse",
			en: "results",
		},
		labelPrevious: {
			de: "Zurück",
			en: "previous",
		},
		labelNext: {
			de: "Vor",
			en: "next",
		},
		ariaLabelPage: {
			de: "Seite",
			en: "Page",
		},
	},
};

export default translations;
